"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showBackgroundColor = exports.showBackground = exports.passcodeLandingPage = void 0;
var _cccisdLaravelFlow = require("cccisd-laravel-flow");
var showBackgroundColor = exports.showBackgroundColor = function showBackgroundColor(selectedColor) {
  switch (selectedColor) {
    case 'primaryColor':
      return '#337AB7';
    case 'successColor':
      return '#5CB85C';
    case 'infoColor':
      return '#5BC0DE';
    case 'warningColor':
      return '#F0AD4F';
    case 'dangerColor':
      return '#D9534F';
    default:
      return selectedColor;
  }
};
var showBackground = exports.showBackground = function showBackground(val, upload) {
  if (!val || val === 'solidColor') {
    return null;
  }
  if (val === 'uploadedImage') {
    return "url(".concat(upload.url, ")");
  }
  return "url(".concat(_cccisdLaravelFlow.backgrounds[val].imageUrl, ")");
};
var passcodeLandingPage = exports.passcodeLandingPage = function passcodeLandingPage(path) {
  var defaultDeploymentUrl = new RegExp('^/d/[A-Za-z0-9_]{7}/?');
  if (defaultDeploymentUrl.test(path)) {
    var deploymentStartUrl = path.split('/').slice(0, 3).join('/');
    return "".concat(deploymentStartUrl);
  }
  return "".concat(path);
};